import getAuthCookie from "../auth/getAuthCookie";
import config from "../config/config-server";

async function getReservations() {
    const API_RESERVATIONS = `${config.apiUrl}/api/reservation/get-reservations`;

    const token = getAuthCookie('token');

    if (token === null || token === undefined) {
        const data = { message: 'NOT_SESSION' }
        return data;
    } else {
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${token}`);
        headers.append('Content-Type', 'application/json');

        const res = await fetch(API_RESERVATIONS, {
            method: 'POST',
            headers: headers
        })

        const dataSession = await res.json();
        return dataSession;
    }
}

export default getReservations;